import { createSelector } from 'reselect'

import { usersPageSelector } from '../selectors'

const sliceSelector = createSelector(usersPageSelector, ({ migrating }) => migrating)
export const paginationSelector = createSelector(sliceSelector, ({ pagination }) => pagination)
export const isLoadingSelector = createSelector(sliceSelector, ({ isLoading }) => isLoading)

const selectedIdsSelector = createSelector(
  sliceSelector,
  ({ selectedMigrations }) => selectedMigrations.map(({ id }) => id)
)

export const migrationsSelector = createSelector(
  sliceSelector,
  selectedIdsSelector,
  ({ migrations }, selectedIds) => migrations.map((migration) => ({
    ...migration,
    is_selected: selectedIds.includes(migration.id)
  }))
)

export const filterTermSelector = createSelector(
  sliceSelector,
  ({ filter }) => filter
)

export const sortFieldSelector = createSelector(sliceSelector, ({ sortField }) => sortField)
export const sortOrderSelector = createSelector(sliceSelector, ({ sortOrder }) => sortOrder)
